import {
	SettingsGroup,
	SettingsLabel,
	SettingsSelect,
	SettingsDescription,
} from '@components/layerSettings/StyledLayerSettings';

/**
 * Reusable interval selector component for contour detail levels
 * Can be reused for other interval-based layer configurations
 *
 * @param {string} value - Currently selected interval key
 * @param {Function} onChange - Callback when interval changes
 * @param {Array} options - Available interval options
 * @param {Function} getDescription - Function to get description for current selection
 * @param {boolean} disabled - Whether the selector is disabled
 * @param {string} label - Label text for the selector
 */
const IntervalSelector = ({
	value,
	onChange,
	options,
	getDescription,
	disabled = false,
	label = 'Detail Level',
}) => {
	return (
		<SettingsGroup>
			<SettingsLabel>{label}</SettingsLabel>
			<SettingsSelect
				value={value}
				onChange={e => onChange(e.target.value)}
				disabled={disabled}>
				{options.map(opt => (
					<option key={opt.key} value={opt.key}>
						{opt.label}
					</option>
				))}
			</SettingsSelect>
			{getDescription && <SettingsDescription>{getDescription()}</SettingsDescription>}
		</SettingsGroup>
	);
};

export default IntervalSelector;
